// extracted by mini-css-extract-plugin
module.exports = {"supportContainer":"SupportSection_supportContainer__aA5Ik"};